module.exports.structure = require('./src/structure');
